import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-dice',
    templateUrl: './dice.component.html',
    styleUrls: ['./dice.component.scss'],
    standalone: false
})
export class DiceComponent {
    @Input() rolls!: any;
    @Input() color!: string;
}